import styled from "styled-components";

export const InfoContainer = styled.div`
    width: 100%;
    min-height: 700px;    
    justify-content: center;  
    display: flex;

`

export const InfoWrapper = styled.div`
    display: flex;
    padding: 80px 0;
    width: 1200px;
    justify-content: center;
    align-items: center;

`

export const Title = styled.h1`
    font-weight: 900;
    color: #B05FFD;
`

export const Subtitle = styled.h5`
    color: #B05FFD;
    font-weight: 500;
    text-transform: uppercase;

`